module.exports = __webpack_public_path__ + "static/media/vignette_01.6b1a6a8f.png";